<template>
  <div class="layout">
    <notification-message class="notification" />

    <div class="email">
      <v-card elevation="0" class="cardEmail">
        <v-card-title>{{ $t("emailRecord.title") }}</v-card-title>
        <v-form ref="form">
          <v-row>
            <v-col>
              <v-card-text>
                <!-- START - Select a list of users at whom to send emails -->
                <v-autocomplete
                  :items="users"
                  v-model="mailingList.usersId"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('emailRecord.users')"
                  multiple
                  clearable
                  color="grey"
                ></v-autocomplete>
                <!-- END - Select a list of users at whom to send emails -->
              </v-card-text>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <!-- START - Select a range of dates for interventions -->
              <v-menu
                v-model="datePickerStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-card-text>
                    <v-text-field
                      v-model="mailingList.dateStart"
                      :label="$t('emailRecord.dateStart')"
                      prepend-icon="mdi-calendar"
                      readonly
                      clearable
                      color="grey"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </v-card-text>
                </template>

                <v-date-picker
                  v-model="mailingList.dateStart"
                  :max="mailingList.dateEnd"
                  :locale="this.$i18n.locale"
                  color="red darken-1"
                  @input="datePickerStart = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                v-model="datePickerEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-card-text>
                    <v-text-field
                      v-model="mailingList.dateEnd"
                      :label="$t('emailRecord.dateEnd')"
                      prepend-icon="mdi-calendar"
                      readonly
                      clearable
                      color="grey"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </v-card-text>
                </template>

                <v-date-picker
                  v-model="mailingList.dateEnd"
                  :min="mailingList.dateStart"
                  :locale="this.$i18n.locale"
                  color="red darken-1"
                  @input="datePickerEnd = false"
                ></v-date-picker>
              </v-menu>
              <!-- END - Select a range of dates for interventions -->
            </v-col>
          </v-row>

          <v-card-actions class="d-flex align-end flex-column">
            <v-btn
              class="error"
              :disabled="$v.mailingList.$invalid"
              @click="sendEmail"
            >
              {{ $t("emailRecord.send") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { getSendEmailToEmployeesHttp } from "@/services/planning/EmailService.js";
import NotificationMessage from "@/components/components-base/notification/NotificationMessage.vue";

export default {
  props: [],
  components: {
    NotificationMessage,
  },
  mixins: [validationMixin],
  validations: {
    mailingList: {
      dateStart: {
        required,
      },
      dateEnd: {
        required,
      },
      usersId: {
        required,
      },
    },
  },
  data() {
    return {
      mailingList: {
        usersId: null,
        dateStart: null,
        dateEnd: null,
      },
      datePickerStart: false,
      datePickerEnd: false,
    };
  },
  computed: {
    ...mapGetters("userModule", {
      users: "getUsersExisting",
    }),
  },
  mounted() {
    this.loadLocations();
    this.loadUsers();
  },
  methods: {
    ...mapActions("notificationModule", ["showNotification"]),
    ...mapActions("userModule", ["loadUsers"]),
    ...mapActions("locationModule", ["loadLocations"]),
  /**
   * This method will send events between the two dates selected in an email to each person selected. Everybody will receive only their own interventions.
   * The object mailingList is used in this method => mailingList: { usersId: null, dateStart: null, dateEnd: null },
   * mailingList has an array of users id to know at who we have to send emails.
   * dateStart and dateEnd represents the interval for events.
   */
    sendEmail() {
      getSendEmailToEmployeesHttp(this.mailingList)
        .then((response) => {
          if (response.status === 200) {
            this.showNotification({
              messageAlert: this.$t("messageStores.emailSendSuccess"),
              typeAlert: "success",
            });
            this.mailingList.usersId = null;
            this.mailingList.dateStart = null;
            this.mailingList.dateEnd = null;
          }
        })
        .catch((error) => {
          this.showNotification({
            messageAlert: this.$t("messageStores.emailSendError"),
            typeAlert: "error",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.layout {
  margin: 0 1rem;
  width: 100%;
}

.email {
  margin: 3rem auto;
  width: 80%;
}

.cardEmail {
  padding: 3rem 3rem;
}

.notification {
  position: absolute;
}
</style>
